import { render, staticRenderFns } from "./AssignedCourses.vue?vue&type=template&id=5f46b73d&scoped=true&"
import script from "./AssignedCourses.vue?vue&type=script&lang=ts&"
export * from "./AssignedCourses.vue?vue&type=script&lang=ts&"
import style0 from "./AssignedCourses.vue?vue&type=style&index=0&id=5f46b73d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f46b73d",
  null
  
)

component.options.__file = "AssignedCourses.vue"
export default component.exports